export const ROLES = {
  ADMIN: 'ADMIN',
  OWNER: 'OWNER',
};
